<template>
  <div class="screenshot-manager">
    <!-- Существующие скриншоты -->
    <div v-if="existingScreenshots.length" class="existing-screenshots">
      <h4>Текущие скриншоты</h4>
      <div class="screenshot-grid">
        <div v-for="(screenshot, index) in existingScreenshots" :key="index" class="screenshot-item">
          <img :src="screenshot.src" :alt="'Скриншот ' + (index + 1)" class="screenshot-image">
          <button @click="removeScreenshot(screenshot)" class="remove-btn">×</button>
        </div>
      </div>
    </div>

    <!-- Загрузка новых скриншотов -->
    <div class="upload-section">
      <div :class="['dropZone', dragging ? 'dropZone-over' : '']"
           @dragenter="dragging = true"
           @dragleave="dragging = false"
           @dragover.prevent
           @drop.prevent="handleDrop">
        <div class="dropZone-info">
          <span class="fa fa-cloud-upload dropZone-title"></span>
          <span class="dropZone-title">Перетащите сюда скриншоты для загрузки</span>
          <div class="dropZone-upload-limit-info">
            <div>Максимальный размер: 5MB на файл</div>
          </div>
        </div>
        <input type="file" ref="fileInput" @change="handleFileChange" multiple accept="image/*" style="display: none;">
      </div>
      <button @click="triggerFileInput" class="btn btn-sm btn-primary mt-2">Выбрать файлы</button>

      <!-- Превью новых скриншотов -->
      <div v-if="newScreenshots.length" class="preview-section mt-3">
        <h5>Новые скриншоты для загрузки:</h5>
        <div class="preview-grid">
          <div v-for="(file, index) in newScreenshots" :key="'new-'+index" class="preview-item">
            <img :src="file.preview" :alt="file.name" class="preview-image">
            <button @click="removeNewScreenshot(index)" class="remove-btn">×</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    appId: {
      type: Number,
      required: true
    },
    appName: {
      type: String,
      required: true
    },
    initialScreenshots: {
      type: Array,
      default: () => []
    }
  },
  emits: ['screenshots-updated'],
  data() {
    return {
      existingScreenshots: [],
      newScreenshots: [],
      dragging: false
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.addFiles(Array.from(event.target.files));
      event.target.value = '';
    },
    handleDrop(event) {
      this.dragging = false;
      this.addFiles(Array.from(event.dataTransfer.files));
    },
    addFiles(files) {
      files.forEach(file => {
        if (!file.type.match('image.*')) return;

        if (file.size > 5 * 1024 * 1024) {
          alert(`Файл ${file.name} слишком большой. Максимальный размер 5MB.`);
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.newScreenshots.push({
            file,
            name: file.name,
            preview: e.target.result
          });
        };
        reader.readAsDataURL(file);
      });
    },
    removeNewScreenshot(index) {
      this.newScreenshots.splice(index, 1);
    },
    async removeScreenshot(screenshot) {
      if (!confirm('Удалить этот скриншот?')) return;

      try {
        await axios.delete(`/api/screenshots/${screenshot.id}`, {
          data: { appId: this.appId }
        });

        this.existingScreenshots = this.existingScreenshots.filter(
          s => s.id !== screenshot.id
        );

        this.$emit('screenshots-updated', this.existingScreenshots);
      } catch (error) {
        console.error('Ошибка удаления скриншота:', error);
        alert('Не удалось удалить скриншот');
      }
    },
    async uploadNewScreenshots() {
      if (!this.newScreenshots.length) return [];

      const formData = new FormData();
      formData.append('appId', this.appId);
      formData.append('appName', this.appName);

      this.newScreenshots.forEach((screenshot, index) => {
        formData.append(`screen[${index}]`, screenshot.file);
      });

      try {
        const response = await axios.post('/api/screenshots', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        return response.data;
      } catch (error) {
        console.error('Ошибка загрузки скриншотов:', error);
        throw error;
      }
    },
    loadImages(images) {
      this.existingScreenshots = images.map(img => ({
        id: img.id,
        src: img.src
      }));
    },
      clearNewScreenshots() {
          this.newScreenshots = []
          console.log(1111);
          this.$emit('screenshots-updated', this.existingScreenshots);
      },
      getScreenshotData() {
      return {
        newFiles: this.newScreenshots.map(s => s.file),
        existingUrls: this.existingScreenshots.map(s => s.src)
      };
    }
  },
  watch: {
    initialScreenshots: {
      immediate: true,
      handler(newVal) {
        this.existingScreenshots = [...newVal];
      }
    }
  }
};
</script>

<style scoped>
.screenshot-manager {
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 4px;
}

.screenshot-grid, .preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.screenshot-item, .preview-item {
  position: relative;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.screenshot-image, .preview-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropZone {
  width: auto;
  height: auto;
  min-height: 150px;
  position: relative;
  border: 2px dashed #eee;
  padding: 20px;
  text-align: center;
}

.dropZone-over {
  background: #f5f5f5;
  border-color: #2e94c4;
}

.dropZone-title {
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.fa-cloud-upload {
  font-size: 24px;
  margin-bottom: 10px;
  color: #2e94c4;
}

.dropZone-upload-limit-info {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}
</style>
